import React from 'react';
import AdminTablesImg from '@/components/Admin/reusableComponents/AdminTablesImg';
import { getInitials, getRandomColor } from '@/_helpers';
import { AdminTable } from '@/components/Admin/reusableStyles';
import MoveStaffModal from './modals/MoveStaffModal';

const StaffTable = ({ staff, isLoading, unassignedList, providerId, onSave }) => {
    if (isLoading) {
        return (
            <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    if (staff.length === 0) {
        return (
            <div className="text-center py-4">
                <p className="text-muted">No staff members found.</p>
            </div>
        );
    }

    return (
        <AdminTable className="w-100 text-dark-grey">
            <thead>
                <tr>
                    <th style={{ width: '60px' }}>Avatar</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {staff.map((staffMember) => {
                    // Prepare employee data for AdminTablesImg
                    const employee = {
                        ...(staffMember || {}),
                        initials: getInitials(`${staffMember.firstName} ${staffMember.lastName}`),
                        color: getRandomColor(staffMember._id),
                    };

                    return (
                        <tr key={staffMember._id} className="align-middle">
                            <td>
                                <AdminTablesImg item={employee} />
                            </td>
                            <td>
                                {staffMember.firstName} {staffMember.lastName}
                            </td>
                            <td>{staffMember.user?.email || 'N/A'}</td>
                            <td>
                                <MoveStaffModal
                                    staff={staffMember}
                                    unassignedList={unassignedList}
                                    providerId={providerId}
                                    onSave={onSave}
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </AdminTable>
    );
};

export default StaffTable;
